const registrationVuexModule = {
  state: {
    inRegistration: false,
    registeringUser: undefined,
  },

  mutations: {
    setInRegistration (state, inRegistration) { state.inRegistration = inRegistration; },
    setRegisteringUser (state, userData) { state.registeringUser = userData; }
  },

  getters: {
    inRegistration: state => state.inRegistration,
    registeringUser: state => state.registeringUser,
    fullName: (_state, getters) =>
      getters.registeringUser != undefined
        ? `${getters.registeringUser.name} ${getters.registeringUser.surname}`
        : undefined
  }
};
  
export default registrationVuexModule;